export default "__VITE_ASSET__BLB0YI18__"